import { setUpAPIExchange } from "../Utils/api.utils";
import AUCTIONS_DATA from "./fake/auctions";
import PORTFOLIO_METRICS, { PORTFOLIO_PENDINGS } from "./fake/portfolio-metrics";

import { setUpAPI } from '../Utils/api.utils';

export const fetchData = async (user_id, pageCount, pageIndex) => {
    try {
        const data = {
            action: 'getAllAuctions',
            user_id: user_id,
            pageIndex: pageIndex,
            pageCount: pageCount,
        };

        const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null);
        const dataRequest = await apiResponse.json();

        const response = dataRequest.map(item => ({
            status: item.status,
            title: item.title,
            imgSrc: item.imgSrc,
            videos: item.videos,
            startDate: item.startDate,
            minUnitPrice: item.minUnitPrice,
            comitted: item.comitted,
            endDate: item.endDate,
            startDateFormat: item.startDateFormat,
            endDateFormat: item.endDateFormat,
            listingType: item.listingType,
            description: item.description,
            start_price: item.start_price,
            minAuctionTarget: item.minAuctionTarget,
            units: item.units,
            auctionID: parseInt(item.auctionID),
            isFromDB: item.isFromDB,
            minimum_price: item.minimum_price,
            maximum_price: item.maximum_price,
            targetPricePerUnit: item.targetPricePerUnit,
            CurrentAuctionPrice: item.CurrentAuctionPrice,
            AverageBid: item.AverageBid,
            BidedUnits: item.BidedUnits,
            progress: item.progress,
            minimum_price_num: item.minimum_price_num,
            maximum_price_num: item.maximum_price_num,
            entryid: item.entryid,
            step: item.step,
            stepFormat: item.stepFormat,
            averageYield: item["3YearAverageYield"] || 0,
            LTMYield: item["Last12MonthsYield"] || 0,
            onWatchList: Math.round(Math.random()),
        }));

        const size = response.length;

        const start = (pageIndex - 1) * parseInt(pageCount, 10);
        const end = start + parseInt(pageCount, 10);

        const paginatedResponse = response.slice(start, end);
        paginatedResponse.totalRows = size;
        return paginatedResponse;
    } catch (error) {
        console.error('Error Call: ', error);
        throw error;
    }
};

export const fetchDataTradingBoard = async (user_id, pageCount, pageIndex) => {
    try {
        const data = {
            action: 'iAuctions_TradingBoard',
            user_id: user_id,
            pageIndex: pageIndex,
            pageCount: pageCount,
        };

        const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null);
        const dataRequest = await apiResponse.json();

        const response = dataRequest.map(item => ({
            status: item.status,
            title: item.title,
            imgSrc: item.imgSrc,
            videos: item.videos,
            startDate: item.startDate,
            minUnitPrice: item.minUnitPrice,
            comitted: item.comitted,
            endDate: item.endDate,
            startDateFormat: item.startDateFormat,
            endDateFormat: item.endDateFormat,
            listingType: item.listingType,
            description: item.description,
            start_price: item.start_price,
            minAuctionTarget: item.minAuctionTarget,
            units: item.units,
            auctionID: parseInt(item.auctionID),
            isFromDB: item.isFromDB,
            minimum_price: item.minimum_price,
            maximum_price: item.maximum_price,
            targetPricePerUnit: item.targetPricePerUnit,
            CurrentAuctionPrice: item.CurrentAuctionPrice,
            AverageBid: item.AverageBid,
            BidedUnits: item.BidedUnits,
            progress: item.progress,
            minimum_price_num: item.minimum_price_num,
            maximum_price_num: item.maximum_price_num,
            entryid: item.entryid,
            step: item.step,
            stepFormat: item.stepFormat,
            averageYield: item["3YearAverageYield"] || 0,
            LTMYield: item["Last12MonthsYield"] || 0,
            onWatchList: Math.round(Math.random()),
        }));

        const size = response.length;

        const start = (pageIndex - 1) * parseInt(pageCount, 10);
        const end = start + parseInt(pageCount, 10);

        const paginatedResponse = response.slice(start, end);
        paginatedResponse.totalRows = size;
        return paginatedResponse;
    } catch (error) {
        console.error('Error Call: ', error);
        throw error;
    }
};


export const addToWatchList = async (user_id, auction) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            action: "addToWatchList",
            user_id: user_id,
            ...auction
        }

        const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
        }
        tempData = { ...response, onWatchList: 1 }

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }
    });
}

export const removeFromWatchList = async (user_id, auction) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            action: "removeFromWatchList",
            user_id: user_id,
            ...auction
        }

        const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
        }

        tempData = { ...response, onWatchList: 0 }

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }
    });
}

export const getPortfolioMetrics = async (user_id) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            action: "getPortfolioMetrics",
            user_id: user_id
        }

        const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
        }

        tempData = [...response, ...PORTFOLIO_METRICS];

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }

    })
}
export const getPortfolioPendings = async (user_id) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            cmd: "mPortfolio_pending",
            UserId: user_id
        }

        const apiResponse = await setUpAPI('mPortfolio', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];
        var response2 = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
            response2 = response.map(item => {
                return {
                    imgSrc: item?.imgSrc[0] ?? null,
                    symbol: item?.Symbol,
                    name: item?.name,
                    orderType: item?.OrderType,
                    bidPerUnit: item?.bid_per_unit,
                    bidUnits: item?.total_units,
                    askPerUnit: item?.unit_price,
                    units: item?.units,
                    finalTotalUnits: item?.final_total_units,
                    auction_id: item?.auction_id,
                    listingName: item?.listingName,
                    id: item?.id,
                    feePercentage: item?.feePercentage,
                    cancelButton: false,
                    date_end:item?.date_end,
                    orderStatus:item?.order_status,
                    finalTotal:item?.finalTotal,
                    formattedBid_per_unit:item?.formattedBid_per_unit,
                    formattedTotal:item?.formattedTotal
                };
            }).filter(item => item !== null);
        }

        tempData = [...response2];

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }

    });
}
export const getPortfolioPast = async (user_id) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            cmd: "mPortfolio_past",
            UserId: user_id
        }

        const apiResponse = await setUpAPI('mPortfolio', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];
        var response2 = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
            response2 = response.map(item => {
                return {
                    imgSrc: item?.imgSrc[0] ?? null,
                    symbol: item?.Symbol,
                    name: item?.name,
                    orderType: item?.OrderType,
                    bidPerUnit: item?.bid_per_unit,
                    finalTotal: item?.finalTotal,
                    bidUnits: item?.total_units,
                    askPerUnit: item?.unit_price,
                    units: item?.units,
                    finalTotalUnits: item?.final_total_units,
                    auction_id: item?.auction_id,
                    listingName: item?.listingName,
                    id: item?.id,
                    feePercentage: item?.feePercentage,
                    cancelButton: false,
                    date_end:item?.date_end,
                    orderStatus:item?.order_status,
                    formattedBid_per_unit:item?.formattedBid_per_unit,
                    formattedTotal:item?.formattedTotal
                };
            }).filter(item => item !== null);
        }

        tempData = [...response2];

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }

    });
}
export const getPortfolioOwned = async (user_id) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            cmd: "mPortfolio_owned",
            UserId: user_id
        }

        const apiResponse = await setUpAPI('mPortfolio', data, 'POST', null).catch(error => {
            reject(error);
        });
        var tempData = undefined;

        var response = [];
        var response2 = [];

        var resText = await apiResponse.text();

        if (resText && resText != "[resultData]") {
            response = JSON.parse(resText);
            response2 = response.map(item => {
                return {
                    Symbol: item?.Symbol,
                    imgSrc: item?.imgSrc,
                    name: item?.title,
                    dalyGain: item?.dalyGain,
                    totalGain: item?.totalGain,
                    lastPrice: item?.lastPrice,
                    royalties: item?.royalties,
                    AveCost: item?.aveCost,
                    AuctionId: item?.auction_id,
                };
            }).filter(item => item !== null);
        }

        tempData = [...response2];

        if (tempData) {
            resolve(tempData);
        } else {
            reject(`There was an error retrieving the data, please try again.`);
        }

    });
}


export const fetchPortfolioData = async (user_id) => {
    return await new Promise(async (resolve, reject) => {
        const data = {
            action: "getAllAuctions",
            user_id: user_id
        };

        try {
            const apiResponse = await setUpAPI('DuthAuction', data, 'POST', null);
            const dataRequest = await apiResponse.json();

            const response = dataRequest.map(item => {
                return {
                    status: item.status,
                    title: item.title,
                    imgSrc: item.imgSrc,
                    videos: item.videos,
                    startDate: item.startDate,
                    minUnitPrice: item.minUnitPrice,
                    comitted: item.comitted,
                    endDate: item.endDate,
                    startDateFormat: item.startDateFormat,
                    endDateFormat: item.endDateFormat,
                    description: item.description,
                    start_price: item.start_price,
                    minAuctionTarget: item.minAuctionTarget,
                    units: item.units,
                    auctionID: parseInt(item.auctionID),
                    isFromDB: item.isFromDB,
                    minimum_price: item.minimum_price,
                    maximum_price: item.maximum_price,
                    targetPricePerUnit: item.targetPricePerUnit,
                    CurrentAuctionPrice: item.CurrentAuctionPrice,
                    AverageBid: item.AverageBid,
                    BidedUnits: item.BidedUnits,
                    progress: item.progress,
                    listingType: item.listingType,
                    symbol: item.symbol,
                    minimum_price_num: item.minimum_price_num,
                    maximum_price_num: item.maximum_price_num,
                    entryid: item.entryid,
                    step: item.step,
                    stepFormat: item.stepFormat,
                    onWatchList: item.onWatchList || 1,
                    portfolioStatus: item.portfolioStatus
                };
            }).filter(item => item !== null);


            const owned = response.filter(auction => auction.portfolioStatus === "owned").map((item, index) => ({ ...item, id: `owd${index}` }));
            const past = response.filter(auction => auction.portfolioStatus === "past").map((item, index) => ({ ...item, id: `pst${index}` }));
            const watchlist = response.filter(auction => auction.onWatchList).map((item, index) => ({ ...item, id: `wtl${index}` }));
            const pending = response.filter(auction => auction.portfolioStatus === "pending").map((item, index) => ({ ...item, id: `pdg${index}` }));
            const offline = response.filter(auction => auction.portfolioStatus === "offline").map((item, index) => ({ ...item, id: `oln${index}` }));

            resolve(JSON.stringify({ owned, pending, offline, past, watchlist }));
        } catch (error) {
            reject(`There was an error retrieving the data, please try again. Error: ${error}`);
        }
    });
};


// Portfolio data exc

export const getPairList = async () => {
    try {
        const response = await setUpAPIExchange(
            "orders/v1/order/user/pair_list",
            null,
            "GET",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

// Portfolio data exc

export const getPairListPagination = async (data) => {
    try {
        const response = await setUpAPIExchange(
            "orders/v1/order/user/pagination_pair_list",
            null,
            "GET",
            data
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

export const getPairListWithSymbol = async (pairName) => {
    try {
        const queryParams = pairName ? `?pairName=${encodeURIComponent(pairName)}` : '';
        const response = await setUpAPIExchange(
            `graph/v1/graph/user/statistics${queryParams}_USD`,
            null,
            "GET",
            null
        );
        return await response.json();
    } catch (error) {
        console.log(error, "error");
        throw new Error('Error fetching pair list with symbol');
    }
};


export const getPairList2 = async (user_id) => {
    try {
        const response = await setUpAPI(
            "mAuctions",
            {
                cmd: 'iAuctions_GetTradingBoard',
                UserId: user_id
            },
            "POST",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

export const updateFavorite = async (userId, auctionId) => {
    try {
        const response = await setUpAPI(
            "WatchList",
            {
                cmd: 'UpdateFavorite',
                auction_id: auctionId,
                user_id: userId
            },
            "POST",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};


export const getUserPortfolio = async (page, limit) => {
    try {
        const response = await setUpAPIExchange(
            `wallet/v1/wallet/user/user_portfolio?page=${page}&limit=${limit}`,
            null,
            "GET",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

export const getOrderHistory = async (page, limit) => {
    try {
        const response = await setUpAPIExchange(
            `orders/v1/order/user/my_orders?page=${page}&limit=${limit}&type=pending`,
            null,
            "GET",
            null
        );
        const json = await response.json()
        var orderHistoryData = json?.data?.orderlist || [];
        var data;
        if (orderHistoryData) {
            data = orderHistoryData.map(item => {
                return {
                    imgSrc: checkStringNull(item?.auction_image) ?? null,
                    symbol: item?.symbol,
                    name: item?.name,
                    orderType: item?.OrderType,
                    bidPerUnit: item?.price,
                    bidUnits: item?.final_total_units,
                    askPerUnit: item?.unit_price,
                    units: item?.total_units,
                    finalTotalUnits: item?.total_units,
                    type: item?.type,
                    auction_id: item?.auction_id,
                    listingName: checkStringNull(item?.listing_name),
                    id: item?.id,
                    fee: item?.fee,
                    cancelButton: true,
                    "years_3_yield": item['years_3_yield'],
                    months_12_yield: item?.months_12_yield,
                    price: item?.price,
                    weeklyVolume: item?.weeklyVolume,
                    change: item?.change,
                    change_percentage: item?.change_percentage,
                    executed_price: item?.executed_price,
                    quantity: item?.quantity,
                    filled_amount: item?.filled_amount,
                    is_active: item?.is_active,
                    side: item?.side
                };
            }).filter(item => item !== null);
        }
        return { data, count: json?.data?.count };
    } catch (error) {
        return console.log(error, "error")
    }
};

const checkStringNull = (value) => {
    return value != 'null' ? value : ''
}

export const getOpenOrders = async (page, limit) => {
    try {
        const response = await setUpAPIExchange(
            `orders/v1/order/user/my_orders?page=${page}&limit=${limit}&type=past`,
            null,
            "GET",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

export const getWatchlist = async (userId) => {
    try {
        const response = await setUpAPI(
            "WatchList",
            {
                cmd: 'getAll',
                user_id: userId
            },
            "POST",
            null
        );
        return await response.json();
    } catch (error) {
        return console.log(error, "error")
    }
};

export const cancelOrder = async (id, symbol) => {

    try {
        const body = {
            pairName: symbol,
            orderId: id
        }

        const response = await setUpAPIExchange(
            "orders/v1/order/user/canceled_order",
            body,
            'PUT',
            null
        )

        return response.json()
    }
    catch (error) {
        console.error(error)
    }

}
